import {
	useSafeAreaNative,
	StatusbarStyle,
} from '/src/native/useSafeAreaNative.js';

import { useDark } from '/src/composables/useDark.js';
import { watch } from 'vue';

const isDark = useDark();
const {
	setImmersiveNavigationBar,
} = useSafeAreaNative();

let unwatch = null;
export function useStatusBarService () {
	async function start () {
		stop();

		unwatch = watch(() => isDark.value, (value) => {
			const style = !value ? StatusbarStyle.Light : StatusbarStyle.Dark;
			setImmersiveNavigationBar({
				statusBarStyle: style,
			});
		}, { immediate: true });
	}

	function stop () {
		if (unwatch) {
			unwatch();
			unwatch = null;
		}
	}

	return {
		start,
		stop,
	};
}
